import React, { useEffect } from 'react';
import { AuthData, withAuthContext } from '../context/auth';

interface Props {
	authData: AuthData;
}

const CustomAssets = (props: Props) => {
	const { authData } = props;

	if (!authData?.auth?.hostName) {
		return null;
	}

	const insertJavascriptTag = () => {
		const existingTag = document.getElementById('custom-js');

		if (existingTag) {
			existingTag.parentNode.removeChild(existingTag);
		}

		const customJavascriptUrl = `${__CUSTOM_ASSETS_URL__}${authData.auth.hostName}-custom.js`;
		const script = document.createElement('script');
		script.id = 'custom-js';
		script.type = 'text/javascript';
		script.src = customJavascriptUrl;
		document.getElementsByTagName('head')[0].appendChild(script);
	};

	useEffect(() => {
		if (__CUSTOM_ASSETS_URL__ && authData?.auth?.hostName) {
			insertJavascriptTag();
		}
	}, [authData?.auth?.hostName]);

	return <></>;
};

export default withAuthContext(CustomAssets);
